const ALL_TYPES = ['excludeDisposalCosts', 'includeDisposalCosts', 'onlyDisposalCosts'] as const

export type InsightsDisposalCostType = (typeof ALL_TYPES)[number];

export const isInsightsDisposalCostType = (value: string): value is InsightsDisposalCostType => {
  return ALL_TYPES.includes(value as InsightsDisposalCostType);
}
